import styled from 'styled-components';
import {Grid} from '@material-ui/core';

const GridFix = styled(Grid)`
  &&&{
      flex-basis: auto;
  }
`;
export default GridFix;
